export const pkg = {
  name: 'isomorphic-git',
  version: '1.33.0',
  agent: 'git/isomorphic-git@1.33.0',
}
